import MarkhamLogo from '@nv/images/logos/markham/markham-logo'

export const fnTheme = {
  bgColor: 'var(--color-white)',
  textColor: 'var(--color-black)',
  logos: { en: MarkhamLogo },
  Logo: MarkhamLogo,
  MobileLogo: MarkhamLogo,
}
